import { defineComponent as _defineComponent } from 'vue'
import { RawLocation } from 'vue-router';
import { TVulnerability } from '@/_core/entities/vulnerability/models/types';
import VulnerabilitySeverity from '@/_core/entities/vulnerability/ui/VulnerabilitySeverity/VulnerabilitySeverity.vue';
import Dropdown, { type TDropdownItem } from '@/_core/shared/ui/Dropdown/Dropdown.vue';
import { computed, getCurrentInstance } from 'vue';
import { useToast } from '@/_core/shared/ui/AppToast/useToast';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportVulnerabilityListItem',
  props: {
    vulnerability: null,
    to: null,
    isInFalsePositivesFolder: { type: Boolean }
  },
  emits: ["mark-as-false-positive", "remove-from-false-positives"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'mark-as-false-positive'): void;
  (e: 'remove-from-false-positives'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  vulnerability: TVulnerability;
  to: RawLocation;
  isInFalsePositivesFolder: boolean;
};





const instance = getCurrentInstance();
const toast = useToast();

function copyVulnLink() {
  const router = instance?.proxy.$router;
  const { href } = router?.resolve(props.to) || {};

  if (!href) return;

  try {
    navigator.clipboard.writeText(window.location.origin + href);
    toast.success({ message: 'Link copied to clipboard' });
  } catch (error) {
    console.error(error);
    toast.error({ message: 'Failed to copy link' });
  }
}

const actions = computed<TDropdownItem[]>(() => {
  const items: TDropdownItem[] = [
    {
      label: 'Copy Link',
      iconName: 'link',
      action: copyVulnLink,
    },
  ];

  if (props.isInFalsePositivesFolder) {
    items.push({
      label: 'Remove from False Positives',
      iconName: 'link',
      action: () => emit('remove-from-false-positives'),
    });
  } else {
    items.push({
      label: 'Mark as False Positive',
      iconName: 'link',
      action: () => emit('mark-as-false-positive'),
    });
  }

  return items;
});

return { __sfc: true,props, emit, instance, toast, copyVulnLink, actions, VulnerabilitySeverity, Dropdown }
}

})